import React, { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import Button from 'common-ui/button';
import { selectUserInfo } from 'features/auth/authSlice';
import {
  getAdditionalInfo,
  getUserProfileInfo,
  getUserProfileInfoChangesById,
  getUserProfileInfoView,
} from 'features/profile/profileActions';
import { selectAdditionalInfo, selectLoading } from 'features/profile/profileSlice';
import AboutSidebar from 'pages/components/aboutSidebar';
import Navigation from 'pages/components/navigation';
import ProfileHeader from 'pages/components/profileHeader';
import ProfileInfo from 'pages/profile/profileInfo';

import {
  ButtonWrapper,
  Column,
  Container,
  Content,
  PersonalInventoryWrapper,
  Row,
} from './ProfileLayout.styles';

const ProfileLayout = ({ children }) => {
  const userType = localStorage.getItem('userType');
  const additionalInfo = useSelector(selectAdditionalInfo);
  const isLoading = useSelector(selectLoading);
  const { pathname } = useLocation();
  const location = useLocation();
  const fromRef = useRef('');
  const userInfo = useSelector(selectUserInfo);

  const { uuid } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fullAccess =
    (userType === 'Super Admin' && additionalInfo.isSuper === true) ||
    (userType === 'Hr Manager' && additionalInfo.isSuper === false);

  const handleExitEdit = () => {
    if (pathname === `/profile/additional-info/edit/${uuid}`) {
      navigate(`/profile/contacts/${uuid}`);
    } else if (pathname.includes('/personal-info/edit')) {
      navigate(uuid ? `/profile/contacts/${uuid}` : `/profile/contacts`);
    } else {
      const updatedPath = pathname.replace('/edit', '');
      navigate(updatedPath);
    }
  };

  useEffect(() => {
    localStorage.setItem('fullAccess', fullAccess);
  }, [isLoading]);

  useEffect(() => {
    if (!fullAccess && uuid) {
      dispatch(getUserProfileInfoView(uuid));
      dispatch(getAdditionalInfo(uuid));
      return;
    }

    if (uuid) {
      dispatch(getUserProfileInfoChangesById(uuid));
      dispatch(getAdditionalInfo(uuid));
      dispatch(getUserProfileInfo(uuid));
    } else {
      dispatch(getUserProfileInfo());
      dispatch(getAdditionalInfo());
    }

    if (!uuid) {
      localStorage.removeItem('role');
    }
  }, [pathname, uuid, dispatch, fullAccess]);

  const isPersonalInfoTab = pathname.includes('/contacts');

  const handleClickBackToTickets = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (location.state?.from) {
      fromRef.current = location.state.from;
    }
  }, [location.state?.from]);
  return (
    <Container>
      <ProfileHeader />
      {fromRef.current.startsWith('/project-management/tickets') && (
        <ButtonWrapper>
          <Button onClick={handleClickBackToTickets}>{'< Back'}</Button>
        </ButtonWrapper>
      )}

      {uuid &&
        (userInfo.email === 'anjela.ohanyan@fnet.am' ||
          userInfo.email === 'alisa.gazaryan@fnet.am' ||
          userInfo.email === 'silva.achemyan@fnet.am' ||
          userType === 'Super Admin' ||
          userType === 'General Manager') && (
          <PersonalInventoryWrapper>
            <Button
              secondary
              onClick={() =>
                navigate(
                  `/personal/inventory/${uuid}?limit=10&offset=0&usage=Personal+use&view=list`
                )
              }
            >
              Personal Inventory
            </Button>
          </PersonalInventoryWrapper>
        )}

      {pathname.includes('edit') ? (
        <>
          <Button outlined className="back-button" onClick={handleExitEdit}>
            <span>{'<'}</span> Back to profile
          </Button>

          <Content>
            <Row>
              <AboutSidebar />
              <Column>{children}</Column>
            </Row>
          </Content>
        </>
      ) : (
        <Content>
          <Column>
            {!pathname.includes('inventory') && <Navigation />}
            {children}
          </Column>
          {isPersonalInfoTab && <ProfileInfo />}
        </Content>
      )}
    </Container>
  );
};

export default ProfileLayout;
